import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme-vh";

const HeaderContainer = styled.header`
  background-color: blue;
  text-align: center;
  & a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-decoration: none;
  }
  height: ${theme.global.headerHeight}vh;
  padding-right: ${theme.global.gutter * 0.7}rem;
  padding-left: ${theme.global.gutter * 0.7}rem;
  background-color: ${theme.color.primary};
  color: ${theme.color.white};
  display: flex;
  align-items: center;
`;

export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/components/common/PanelLayout/Header/HeaderContainer.tsx